import { PLUGIN_REDUCERS } from "metabase/plugins";
import { shared } from "./reducer";

PLUGIN_REDUCERS.shared = shared.reducer;
